import { RedirectCommand, Routes } from '@angular/router';
import { pageConfig } from './page/page.config';
import { authConfig } from './auth/auth.config';
import { blogConfig } from './blog/blog.config';
import { dashboardConfig } from './dashboard/dashboard.config';
import { PageNotFoundComponent } from './page/components/page-not-found/page-not-found.component';

export const routes: Routes = [

  //---------- no language specified redirects to english ----------//
  {
    path: '',
    redirectTo: '/en',
    pathMatch: 'full'
  },
  {
    path: 'en',
    loadChildren: () =>
      import('./page/page.routes').then(routes => routes.pageRoutes),
    providers: pageConfig.providers
  },
  {
    path: 'de',
    loadChildren: () =>
      import('./page/page.routes').then(routes => routes.pageRoutes),
    providers: pageConfig.providers
  },
  {
    path: 'fa',
    loadChildren: () =>
      import('./page/page.routes').then(routes => routes.pageRoutes),
    providers: pageConfig.providers
  },
  {
    path: 'id',
    loadChildren: () =>
      import('./page/page.routes').then(routes => routes.pageRoutes),
    providers: pageConfig.providers
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./auth/auth.routes').then(routes => routes.authRoutes),
    providers: authConfig.providers
  },
  {
    path: 'blog',
    redirectTo: 'en/blog',
    pathMatch: 'full'
  },
  {
    path: 'en/blog',
    loadChildren: () =>
      import('./blog/blog.routes').then(routes => routes.blogRoutes),
    providers: blogConfig.providers
  },
  {
    path: 'de/blog',
    loadChildren: () =>
      import('./blog/blog.routes').then(routes => routes.blogRoutes),
    providers: blogConfig.providers
  },
  {
    path: 'fa/blog',
    loadChildren: () =>
      import('./blog/blog.routes').then(routes => routes.blogRoutes),
    providers: blogConfig.providers
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./dashboard/dashboard.routes').then(routes => routes.dashboardRoutes),
    providers: dashboardConfig.providers
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];
